import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ModifierGroup from './modifier-group';

const { classNames } = Mobi2Go.helpers;

const ModifierBrowser = ({
    onModifierGroupHeadingClick,
    onModifierClick,
    onModifierQuantityChange,
    onSubProductQuantityAdd,
    onSubProductQuantityRemove,
    onSubProductEdit,
    modifier_groups,
}) => {
    const modifier_groups_count = _.keys(modifier_groups).length;
    if (modifier_groups_count === 0) {
        return null;
    }

    return (
        <div className={classNames('m2g-product-editor-modifier-browser')}>
            <div
                className="m2g-product-editor-modifier-list m2g-well"
                data-modifier-groups
            >
                {_.map(modifier_groups, modifier_group => (
                    <ModifierGroup
                        key={modifier_group.id}
                        modifier_group={modifier_group}
                        onHeadingClick={onModifierGroupHeadingClick}
                        onModifierClick={onModifierClick}
                        onModifierQuantityChange={onModifierQuantityChange}
                        onSubProductQuantityAdd={onSubProductQuantityAdd}
                        onSubProductQuantityRemove={onSubProductQuantityRemove}
                        onSubProductEdit={onSubProductEdit}
                    />
                ))}
            </div>
        </div>
    );
};

ModifierBrowser.propTypes = {
    onModifierGroupHeadingClick: PropTypes.func.isRequired,
    onModifierClick: PropTypes.func.isRequired,
    onModifierQuantityChange: PropTypes.func.isRequired,
    onSubProductQuantityAdd: PropTypes.func.isRequired,
    onSubProductQuantityRemove: PropTypes.func.isRequired,
    onSubProductEdit: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    modifier_groups: PropTypes.array.isRequired,
};

export default ModifierBrowser;
